<div class="sp-dialog__max-width-s sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding">
    <h3 class="sp-color__accent">
      {{ 'AUTH.FORGOT_PSS_CONFIRM_TITLE' | translate }}
    </h3>
    <p class="sp-margin__top-x2">
      {{ 'AUTH.FORGOT_PSS_CONFIRM_SUBTITLE' | translate }}
    </p>

    <form
      [formGroup]="pss_reset_confirm_from_group"
      class="sp-margin__top-x2">
      <div class="sp-row__justify sp-row__space sp-margin__bottom-x2 sp-wrap">
        <mat-form-field
          class="sp-form-field sp-form-field__otp sp-form-field__primary-light sp-margin__bottom-x2 sp-form__with-border"
          appearance="fill"
          color="accent"
          [floatLabel]="'always'"
          *ngFor="let control of getFormGroupControls(); let i = index">
          <input
            matInput
            class="sp-text__center"
            inputmode="numeric"
            [maxlength]="i === 0 ? 6 : 1"
            #otp
            formControlName="otp_{{ i }}"
            [attr.autocomplete]="i === 0 ? 'one-time-code' : 'off'"
            [errorStateMatcher]="error_matcher"
            (input)="onMoveToNext($event, i)"
            (keydown)="onMoveToPrev($event, i)"
            (focus)="onSetActiveInput(i)"
            (paste)="onPasteOtp($event, i)"
            required />
        </mat-form-field>
      </div>

      <mat-form-field
        class="sp-width__full sp-form-field sp-margin__bottom-x2"
        [ngClass]="getPssFormFieldErrorClass(false)"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'AUTH.PASSWORD_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          [type]="is_password_visible ? 'text' : 'password'"
          formControlName="password"
          [errorStateMatcher]="error_matcher"
          required />
        <mat-icon
          matSuffix
          class="sp-color__primary sp-cursor__pointer"
          (click)="is_password_visible = !is_password_visible">
          {{ is_password_visible ? 'visibility_off' : 'visibility' }}
        </mat-icon>
        <mat-error *ngIf="hasPssLengthError(false)">
          {{ 'ERROR.PASSWORD_LENGTH' | translate }}
        </mat-error>
        <mat-error *ngIf="hasPssPatternError(false)">
          {{ 'ERROR.PASSWORD_PATTERN' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-form-field sp-margin__bottom-x4"
        [ngClass]="getPssFormFieldErrorClass(true)"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'AUTH.PASSWORD_CONFIRM_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          [type]="is_password_visible ? 'text' : 'password'"
          formControlName="password_confirm"
          [errorStateMatcher]="error_matcher"
          required />
        <mat-icon
          matSuffix
          class="sp-color__primary sp-cursor__pointer"
          (click)="is_password_visible = !is_password_visible">
          {{ is_password_visible ? 'visibility_off' : 'visibility' }}
        </mat-icon>
        <mat-error *ngIf="hasPssLengthError(true)">
          {{ 'ERROR.PASSWORD_LENGTH' | translate }}
        </mat-error>
        <mat-error *ngIf="hasPssPatternError(true)">
          {{ 'ERROR.PASSWORD_PATTERN' | translate }}
        </mat-error>
      </mat-form-field>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="!isFormValid() || is_forgot_pss_confirm_running"
        [is_spinner_visible]="is_forgot_pss_confirm_running"
        (click)="onPssResetClick()"></app-shared-button>
    </form>
  </div>
</div>
